import classNames from 'classnames';

import { SectionTitle, Faq } from '@/ui/index';
import { InfoQuestion } from '@/icons/index';

import styles from './ServicesFaq.module.scss';

const ServicesFaq = ({ data, className }) => {
  return (
    <section
      className={classNames(styles['service-faq'], className)}
      itemScope
      itemType='https://schema.org/FAQPage'
    >
      {data?.title && (
        <SectionTitle
          className={styles['service-faq__title']}
          titleModify='title--large'
          Icon={InfoQuestion}
        >
          {data.title}
        </SectionTitle>
      )}
      {data?.questions && (
        <Faq className={styles['service-faq__list']} items={data.questions} />
      )}
    </section>
  );
};

export default ServicesFaq;
